// jQuery 전역 설정 (Bootstrap보다 먼저 로드되어야 함)
import $ from '../../lib/jquery-global'

import Vue from 'vue'
import moment from 'moment'
import { createPopper } from '@popperjs/core'
import 'bootstrap'
import 'pace-js'
import PerfectScrollbar from 'perfect-scrollbar'
import '@coreui/coreui'
import Chart from 'chart.js'
import io from 'socket.io-client'
import jscolor from 'jscolor'
import axios from 'axios'
import VueAxios from 'vue-axios'
import '../../lib/logger'

window.moment = moment

// Global 설정
window.Popper = createPopper
window.PerfectScrollbar = PerfectScrollbar
window.Chart = Chart
window.Vue = Vue
window.io = io
window.jscolor = jscolor

import App from './App.vue'
import router from './router'

// use axios plugin
Vue.use(VueAxios, axios)

new Vue({
    render (h) {
        return h(App)
    },
    router,
    mounted () {
        window.dataLayer = window.dataLayer || [];


    }
}).$mount('#app')
